import clsx from "classnames";
import classes from "./styles.module.scss";

export const Breadcrumb = ({ title, items, className }) => {

  return (
    <div className={clsx(className, classes.breadcrumb)}>
      <a href="/">Home</a>
      <span>/</span>
      {items && items.length > 0 ? (
        items.map((item, index) => (
          <span key={index}>
            <a href={item.link}>{item.title}</a>
            {index < items.length - 1 && <span>/</span>}
          </span>
        ))
      ) : (
        <span>{title}</span>
      )}
    </div>
  );
}

export default Breadcrumb;
